import { render, staticRenderFns } from "./CustomDefinedFieldExtendedData.vue?vue&type=template&id=3be58ab2&scoped=true"
import script from "./CustomDefinedFieldExtendedData.vue?vue&type=script&lang=ts"
export * from "./CustomDefinedFieldExtendedData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be58ab2",
  null
  
)

export default component.exports